import { RootState } from '../types'

export const getMainSubcategorySelector = (state: RootState) => state.subCategory
